import initSlider from '../libs/initSlider';
import changeActiveSlide from '../changeActiveSlide';
import { tabsSliderOptions, tabsContentSliderOptions } from '../sliders/sliders';

document.addEventListener('DOMContentLoaded', (e) => {
  const PAGE = 'modules';

  /*  */

  const clientInterfaceTabsSlider = initSlider('[data-client-interface-tabs-slider]', tabsSliderOptions);
  const clientInterfaceSlider = initSlider('[data-client-interface-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: clientInterfaceTabsSlider,
      autoScrollOffset: 0.5,
    },
  });

  clientInterfaceTabsSlider.on('click', (swiper) => {
    changeActiveSlide(swiper, 'back_office');
  });
  clientInterfaceSlider.on('slideChangeTransitionStart', (swiper) => {
    changeActiveSlide(swiper, 'back_office');
  });

  /*  */

  const marketingToolsTabsSlider = initSlider('[data-marketing-tools-tabs-slider]', tabsSliderOptions);
  const marketingToolsSlider = initSlider('[data-marketing-tools-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: marketingToolsTabsSlider,
      autoScrollOffset: 0.5,
    },
  });

  marketingToolsTabsSlider.on('click', (swiper) => {
    changeActiveSlide(swiper, 'back_office');
  });
  marketingToolsSlider.on('slideChangeTransitionStart', (swiper) => {
    changeActiveSlide(swiper, 'back_office');
  });

  /*  */

  const modulesTabsSlider = initSlider('[data-modules-tabs-slider]', tabsSliderOptions);
  const modulesSlider = initSlider('[data-modules-slider]', {
    ...tabsContentSliderOptions,
    thumbs: {
      swiper: modulesTabsSlider,
      autoScrollOffset: 0.5,
    },
  });

  modulesTabsSlider.on('click', (swiper) => {
    changeActiveSlide(swiper, PAGE);
  });
  modulesSlider.on('slideChangeTransitionStart', (swiper) => {
    changeActiveSlide(swiper, PAGE);
  });
});
